export function createScheduledDepartureClient(transport) {
    return {
        /**
         * The routes this tenant runs departures on
         *
         * Requires scope: departure:read
         */
        listRoutes(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/departure-routes",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Add a route
         *
         * Requires scope: departure:write
         */
        createRoute(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/departure-routes",
                body,
                options,
            });
        },
        /**
         * Departures, soonest first
         *
         * Requires scope: departure:read
         */
        listDepartures(limit, after, from, options) {
            return transport.request({
                method: "GET",
                path: "/v1/departures",
                query: { limit: limit, after: after, from: from },
                options,
            });
        },
        /**
         * Schedule a departure, with the seats it has to sell
         *
         * Requires scope: departure:write
         */
        scheduleDeparture(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/departures",
                body,
                options,
            });
        },
        /**
         * One departure, its whole seat map, and the counts
         *
         * Requires scope: departure:read
         */
        getDeparture(departureId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/departures/${encodeURIComponent(departureId)}`,
                options,
            });
        },
        /**
         * Move a departure to boarding, departed or cancelled
         *
         * Requires scope: departure:write
         */
        transitionDeparture(departureId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/departures/${encodeURIComponent(departureId)}/transitions`,
                body,
                options,
            });
        },
        /**
         * Take a seat out of sale while somebody pays for it
         *
         * Requires scope: departure:book
         */
        holdSeat(departureId, seatLabel, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/departures/${encodeURIComponent(departureId)}/seats/${encodeURIComponent(seatLabel)}/hold`,
                body,
                options,
            });
        },
        /**
         * Give a held seat back
         *
         * Requires scope: departure:book
         */
        releaseSeat(departureId, seatLabel, options) {
            return transport.request({
                method: "POST",
                path: `/v1/departures/${encodeURIComponent(departureId)}/seats/${encodeURIComponent(seatLabel)}/release`,
                options,
            });
        },
        /**
         * Sell a held seat to the customer holding it
         *
         * Requires scope: departure:sell
         */
        sellSeat(departureId, seatLabel, options) {
            return transport.request({
                method: "POST",
                path: `/v1/departures/${encodeURIComponent(departureId)}/seats/${encodeURIComponent(seatLabel)}/sell`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=scheduled-departure.js.map